import React from "react"
import Loading from "resource/svg/loading.svg"
import "./index.css"

export default function FullScreenLoading() {
  return (
    <div className="FullScreenLoading">
      <Loading />
    </div>
  )
}
